
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="operation">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!operation.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="operation">

    <div class="column">

      <div class="panel">
        <h2>Opération</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <input id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
          <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
        </div>
        
        <div class="form-group">
          <label for="category">Catégorie</label>
          <t-select *ngIf="user && user.is_admin" name="category" [items]="operationsCategories" [(item)]="categorySelect" (updated)="categorySelectUpdated()"></t-select>
          <span *ngIf="user && !user.is_admin" id="category" class="value">{{ operation.category }}</span>
        </div>
      </div>
      
      <div *ngIf="mode === 'edit'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ operation.id }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date d'ajout</label>
          <span id="created_at" class="value">{{ operation.created_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="created_by">Ajoutée par</label>
          <span id="created_by" class="value">{{ operation.created_by.fullname }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date de modification</label>
          <span id="created_at" class="value">{{ operation.updated_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="updated_by">Modifiée par</label>
          <span id="updated_by" class="value">{{ operation.updated_by.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column"></div>

  </div>
</form>